<section class="tt-ai-chat-conversation-list" aria-label="Conversations">
    <div class="tt-ai-chat-conversation-list__heading">
        <strong ttTranslateWord="tt_heading_chats"></strong>
    </div>

    <p *ngIf="loading" class="tt-ai-chat-conversation-list__status" ttTranslateWord="loading_conversations"></p>
    <p *ngIf="!loading && chats.length === 0" class="tt-ai-chat-conversation-list__status" ttTranslateWord="no_conversations_yet"></p>

    <ng-container *ngIf="providerNamesByKeyno$ | async as providerNamesByKeyno">
        <button
            *ngFor="let chat of chats; trackBy: trackChat"
            type="button"
            class="tt-ai-chat-conversation-list__button"
            [class.tt-ai-chat-conversation-list__button--selected]="chat.ai_chat_keyno === selectedChat?.ai_chat_keyno"
            (click)="chatSelected.emit(chat)"
        >
            <span>{{ chat.ai_chat_name }}</span>
            <small>
                <ng-container *ngIf="providerNamesByKeyno[chat.ai_provider_keyno] as providerName">{{ providerName }} &middot; </ng-container>
                {{ chat.mod_datetime | formatDate: "datetime" : false }}
            </small>
        </button>
    </ng-container>
</section>
